module.exports = __webpack_public_path__ + "static/img/-streaming.8bead2bd.png";